import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const BolsaFamiliaRegister = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <Donut
            title={'Inscrito no Programa Bolsa Família'}
            subtitles={chartData?.bolsaFamiliaRegister?.map((item) => item.description)}
            chartData={chartData?.bolsaFamiliaRegister || []}
            colors={defaultColors.slice(0, chartData?.bolsaFamiliaRegister?.length) || []}
            height={350}
            className="aligned-container"
        />
    );
};
